import { render, staticRenderFns } from "./questionPage.vue?vue&type=template&id=485e31da&"
import script from "./questionPage.vue?vue&type=script&lang=js&"
export * from "./questionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/page/questionPage.vue"
export default component.exports